import React from 'react'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import BlogList from './BlogList'
import PageSEO from '../shared/PageSEO'

const Blog = () => {
  useTranslation()
  
  return (
    <>
      <PageSEO 
        title="Blog | Hyunjin Jae"
        description="Read my thoughts on web development, software engineering, and technology."
        keywords="blog, web development, software engineering, technology"
        tags={['blog', 'web development', 'software engineering']}
      />
      <Box>
        <BlogList />
      </Box>
    </>
  )
}

export default Blog
